import script from "./MainObrasPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MainObrasPage.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/main.css?vue&type=style&index=0&id=3cd9457c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd9457c"]])

export default __exports__